export default "__VITE_ASSET__VwJMjMxS__"